import { 
    obterParametrosDaURL,
    toDataBR
} from "../../../../functions";

import { api } from "../../api";
import { ApiException } from "../../api-exception";

export const ObterVencimentosDoLoteDeContasAPagar = async (idLote: string) => {
  const { token } = obterParametrosDaURL();

  try {
    const { data } = await api.get<string[]>(`/vencimentos-do-lote`, {
      params: { idLote },
      headers: { token },
    });

    return (data.map((vencimento) => toDataBR(vencimento)));
  } catch (erro) {
    throw new ApiException(
      erro,
      "Não foi possível obter os vencimentos do lote informado"
    );
  }
};